const boxShadows = {
  elevation0: `0 0 0 #FFFFFF`,
  elevation1: `2px 2px 10px 0 #9D9DB433`,
  elevation2: '2px 2px 10px 0 #9d9db44d',
  elevation3: '0px 0px 20px 0px #32395A33',
  elevation4: '4px 4px 20px 0 rgba(50, 57, 90, 0.50)',
} as const;

export default boxShadows;
